import Vue from "vue";
import VueRouter from 'vue-router'

import Home from './pages/home'
import About from './pages/about'
import NotFound from './pages/notfound'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/about', name: 'about', component: About },
  { path: '*', name: '404', component: NotFound },
]

export default new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: routes
})
